module.exports = "\n<button \n  (click)=\"login()\"\n  class=\"btn btn-primary\">Login with Google</button>"


//////////////////
// WEBPACK FOOTER
// C:/dev1/Aladin-SHOP/src/app/core/components/login/login.component.html
// module id = ../../../../../src/app/core/components/login/login.component.html
// module chunks = main